import { ClientsEntryConfig, WorkerEntryConfig } from '@modules/project-creator/shared/data/project-entry.config';
import { EntryType } from '@shared/modules/entry/enums/entry-type.enum';

export interface ProjectSummaryDocumentSectionConfig {
  translation: string;
  type: EntryType;
  infoText?: string;
  translationParams?: Record<string, string>;
}

export interface ProjectSummaryDocumentsGroupConfig {
  title: string;
  description: string;
  boxName: 'dataBox2' | 'dataBox3';
  sections: ProjectSummaryDocumentSectionConfig[];
}

const mapSections = (
  config: Array<{ translation: string; type: EntryType; infoText?: string }>
): ProjectSummaryDocumentSectionConfig[] =>
  config.map(({ translation, type, infoText }) => ({
    translation,
    type,
    infoText
  }));

export const ProjectSummaryDocumentsSectionsConfig: ProjectSummaryDocumentsGroupConfig[] = [
  {
    title: 'ProjectsDashboard.summary.documents.generalTitle',
    description: 'ProjectsDashboard.summary.documents.generalInfo',
    boxName: 'dataBox2',
    sections: mapSections(ClientsEntryConfig)
  },
  {
    title: 'ProjectsDashboard.summary.documents.confidentialTitle',
    description: 'ProjectsDashboard.summary.documents.confidentialInfo',
    boxName: 'dataBox3',
    sections: mapSections(WorkerEntryConfig)
  }
];
